import Glide from '@glidejs/glide';

const initGlider = () => {
  const slider = new Glide('.glide', {
    type: 'carousel',
    startAt: 0,
    perView: 3,
    focusAt: 'center',
    peek: {
      before: 300,
      after: 100
    },
    breakpoints: {
      1024: {
        perView: 2
      },
      768: {
        perView: 2,
        peek: {
          before: 100,
          after: 100
        },
      },
      414: {
        perView: 1,
        peek: {
          before: 50,
          after: 50
        },
      }
    }
  })

  slider.mount()
};

document.addEventListener('DOMContentLoaded', () => {
  const gliderExists = document.body.contains(document.getElementsByClassName('glide')[0]);

  if (gliderExists) {
    initGlider();
  }
});
